<template>
    <div v-if="value" class="drawResultModal">
        <div class="wrapper">
            <div class="title" v-html="title"></div>
            <img class="cover" :src="cover">
            <div class="desc" v-html="desc"></div>
            <a class="btn" :href="btnUrl" v-html="btnLabel"></a>
            <a href="javascript:;" class="close" @click="close"></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DrawResultModal',
    props: {
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        cover: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        btnLabel: {
            type: String,
            default: ''
        },
        btnUrl: {
            type: String,
            default: ''
        },
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
    }
};
</script>

<style lang="less" scoped>
.drawResultModal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding: 35px 0 17px;
        background: url('./images/bg.png') no-repeat center;
        background-size: auto 100%;
        .title {
            margin-bottom: 20px;
            text-align: center;
            font-size: 25px;
            line-height: 32px;
            color: #fff;
        }
        .cover {
            display: block;
            margin: 0 auto 20px;
            height: 160px;
            object-fit: contain;
        }
        .desc {
            margin-bottom: 35px;
            line-height: 19px;
            text-align: center;
            font-size: 12px;
            color: #9F9F9F;
        }
        .btn {
            margin: 0 auto;
            display: block;
            width: 210px;
            background-color: #ed732e;
            border-radius: 22px;
            text-align: center;
            line-height: 44px;
            font-size: 21px;
            color: #fff;
        }
        .close {
            position: absolute;
            display: block;
            width: 24px;
            height: 24px;
            background-image: url('./images/close.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            bottom: -56px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
